'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _rcMenu = require('rc-menu');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _tooltip = require('../tooltip');

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var MenuItem = function MenuItem(props, _ref) {
    var inlineCollapsed = _ref.inlineCollapsed;

    return _react2['default'].createElement(
        _tooltip2['default'],
        { title: inlineCollapsed && props.level === 1 ? props.children : '', placement: 'right', overlayClassName: props.rootPrefixCls + '-inline-collapsed-tooltip' },
        _react2['default'].createElement(_rcMenu.Item, props)
    );
};
MenuItem.contextTypes = {
    inlineCollapsed: _propTypes2['default'].bool
};
exports['default'] = MenuItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/menu/MenuItem.js
// module id = 928
// module chunks = 0